export default "__VITE_ASSET__66016ac6__"